<template>
    <v-text-field
      v-model="invoice_number"
      class="text-xs-center"
      label="# Factura"
      outlined
      append-icon="search"
      @click:append="validate_code()"
      @keyup.enter="validate_code()"
      @change="validate_code()"
      @input="clear()"
      :disabled="loadSearch"
      :loading="loadSearch"
      dense hide-details
    >
    </v-text-field>
  </template>
  <script>
  export default {
    name: "FindInvoice",
    props: {

    },
    data: () => ({
      invoice_number: null,
      loadSearch: false,
    }),  
    methods: {
      async validate_code() {
        if (this.invoice_number == "" || this.invoice_number == null) {
            this.$toast.warning("El codigo no puede estar vacio!");
            return;
        }
        try {
          this.loadSearch = true;
         // this.$emit("loading", true);
          const result = await this.api_Get("inventory/find_invoice/"+this.clearInputFilter(this.invoice_number, 0));
          const data = await result.json();
          if (result.status == 200) {
            if ((await data.length) == 0) {
                this.$toast.info("FACTURA NO ENCONTRADA!");
              this.loadSearch = false;
              return;
            }
        
            this.$emit("set-invoice", data);
          } else {
            this.$toast.error(data.error);
          }
        } catch (error) {
            this.$toast.error(error);
        }
        this.loadSearch = false;
      },
      clear() {
          this.$emit("clear", true);
      },
    },
  };
  </script>
  
  
  